/* eslint-disable import/no-anonymous-default-export */
import { colors } from '@mui/material';
import { lighten, darken } from '@mui/material/styles';

const white = '#FFFFFF';
const black = '#000000';
const primaryPurple = '#800AC0';

export default {
  black,
  white,
  primary: {
    contrastText: white,
    dark: darken(primaryPurple, 0.2),
    main: primaryPurple,
    light: lighten(primaryPurple, 0.2),
  },
  // secondary: {
  //   contrastText: white,
  //   dark: colors.blue[900],
  //   main: colors.blue['A400'],
  //   light: colors.blue['A400'],
  // },
  success: {
    contrastText: white,
    dark: colors.green[900],
    main: colors.green[600],
    light: colors.green[400],
  },
  info: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue[600],
    light: colors.blue[400],
  },
  warning: {
    contrastText: white,
    dark: colors.orange[900],
    main: colors.orange[600],
    light: colors.orange[400],
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400],
  },
  text: {
    primary: colors.blueGrey[900],
    secondary: colors.blueGrey[600],
    link: colors.blue[600],
  },
  background: {
    default: '#F4F6F8',
    paper: white,
  },
  icon: colors.blueGrey[600],
  divider: colors.grey[200],
  disabled: {
    background: colors.grey[200],
    text: colors.grey[500],
    icon: colors.grey[300],
  },
};
